import { GridModalFormProps, UseFormReturnType, useForm } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { Params } from "react-router-dom";
import {
  BookingDocumentItem,
  BookingDocumentType,
  getBookingDocumentService,
} from "./bookingDocumentApi";

export interface UseBookingDocumentFormProps extends GridModalFormProps {
  type?: BookingDocumentType;
}

export interface UseBookingDocumentFormReturnType extends UseFormReturnType<BookingDocumentItem> {
  params: Readonly<Params<"booking_id">>;
}

export default function useBookingDocumentForm({
  id,
  afterSave,
  defaultValues,
  type,
}: UseBookingDocumentFormProps): UseBookingDocumentFormReturnType {
  const params = useParams<"booking_id">();
  const scope = params.booking_id ? { bookings: params.booking_id } : undefined;
  const urlParams = type ? { type } : undefined;
  const service = getBookingDocumentService(scope, urlParams);

  const form = useForm<BookingDocumentItem>({
    id,
    translationCategory: "BookingDocument",
    afterSave,
    defaultValues: {
      ...(type ? { type } : {}),
      ...defaultValues,
    },
    ...service,
    loadOptions: undefined,
    ignoreNavigateAfterCreate: true,
  });

  return { ...form, params };
}
